import axios from 'axios';

const PROD_FALLBACK_API_URL = 'https://theskilledgroup-website.onrender.com/api';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? PROD_FALLBACK_API_URL
    : 'http://localhost:5000/api');

let loggedBaseUrl = false;
if (process.env.NODE_ENV !== 'production' && !loggedBaseUrl) {
  loggedBaseUrl = true;
  // eslint-disable-next-line no-console
  console.log(`[API] Base URL: ${API_BASE_URL}`);
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

export const getApiErrorMessage = (error) => {
  const serverMessage = error?.response?.data?.error || error?.response?.data?.message;
  if (serverMessage) return serverMessage;

  // When the browser blocks the response (CORS / mixed-content) or the server is unreachable,
  // Axios errors typically have no `response`.
  if (process.env.NODE_ENV === 'production') {
    return 'Unable to submit your request right now. Please try again in a moment.';
  }

  const baseHint = `Unable to reach the server at ${API_BASE_URL}.`;
  const detail = error?.message ? ` (${error.message})` : '';
  return `${baseHint}${detail}`;
};

// Booking
export const createBooking = async (data) => {
  const response = await api.post('/bookings', data);
  return response.data;
};

// Quote
export const createQuote = async (data) => {
  const response = await api.post('/quotes', data);
  return response.data;
};

// Feedback
export const createFeedback = async (data) => {
  const response = await api.post('/feedback', data);
  return response.data;
};

export const getApprovedFeedback = async () => {
  const response = await api.get('/feedback/approved');
  return response.data;
};

// Contact
export const createContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

// Blog
export const getAllBlogPosts = async () => {
  const response = await api.get('/blog');
  return response.data;
};

export const getBlogPostBySlug = async (slug) => {
  const response = await api.get(`/blog/${slug}`);
  return response.data;
};

export const seedBlogPosts = async () => {
  const response = await api.post('/blog/seed');
  return response.data;
};

export default api;